<template>
    <section>
        <!-- <TopBackgroundComponent/> -->
        <AboutTopComponent/>
        <!-- <HeartCenter/> -->
        <VisionMissionComponent/>
        <MCVCDirector/>
    </section>
</template>

<script setup>
    // import TopBackgroundComponent from '../components/TopBackgroundComponent.vue';
    import AboutTopComponent from '../components/about/AboutTopComponent.vue';
    // import HeartCenter from '@/components/home/HeartCenter.vue';
    import VisionMissionComponent from '../components/about/VisionMissionComponent.vue';
    import MCVCDirector from '../components/about/MCVCDirector.vue';
    window.scrollTo(0, 0);
</script>

<style scoped>
  /*  */
</style>